import { render } from "./ConfirmBack.vue?vue&type=template&id=16953d68&scoped=true&ts=true"
import script from "./ConfirmBack.vue?vue&type=script&lang=ts"
export * from "./ConfirmBack.vue?vue&type=script&lang=ts"

import "./ConfirmBack.vue?vue&type=style&index=0&id=16953d68&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16953d68"]])

export default __exports__